import { Injectable } from '@angular/core';

const STORAGE_KEY = 'pagai_acct_deactivated';

/**
 * Holds a flag indicating that the account-deactivated page may be shown.
 * Set either when an authenticated user is found to be INACTIVE
 * (mid-session deactivation) or when a sign-in attempt fails because the
 * Cognito account is disabled. The page guard reads this flag to prevent
 * direct navigation to /account-deactivated.
 *
 * Persisted in sessionStorage so a hard refresh on /account-deactivated
 * does not bounce the user through the main app shell before landing back.
 */
@Injectable({ providedIn: 'root' })
export class AccountDeactivatedService {
  get signaled(): boolean {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  }

  set signaled(value: boolean) {
    if (value) {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
}
